import { SearchPage } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/SearchPage";
import React from "react";

// Discover page is the search page. (used for SEO purposes)
// We create this so webpack chunk name is different from the search page.
export const DiscoverPage = () => {
  return <SearchPage />;
};
